import { render, staticRenderFns } from "./sellDetail.vue?vue&type=template&id=27cc7a3b&scoped=true&"
import script from "./sellDetail.vue?vue&type=script&lang=ts&"
export * from "./sellDetail.vue?vue&type=script&lang=ts&"
import style0 from "./sellDetail.vue?vue&type=style&index=0&id=27cc7a3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc7a3b",
  null
  
)

export default component.exports